import IconButton from "@/components/atoms/IconButton";
import { ITableHeaderComponentProps } from "@/interfaces/Table";
import {
  faPlus,
  faSearch,
  faShieldAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ElementRef, FC, useRef } from "react";
import { Button, Col, FormControl, InputGroup, Row } from "react-bootstrap";
import StoreCompanyStatusModal from "../modals/company/StoreCompanyStatusModal";
import ManageCompanyStatusPermissionsModal from "../modals/company/ManageCompanyStatusPermissionsModal";

const AllCompanyStatusesHeader: FC<ITableHeaderComponentProps> = ({
  onQueryChange,
}) => {
  const StoreCompanyStatusModalRef =
    useRef<ElementRef<typeof StoreCompanyStatusModal>>(null);
  const ManagePermissionsModalRef =
    useRef<ElementRef<typeof ManageCompanyStatusPermissionsModal>>(null);

  const openCreateModal = () =>
    StoreCompanyStatusModalRef.current?.showOrHiddenModal();

  const openPermissionsModal = () =>
    ManagePermissionsModalRef.current?.showOrHiddenModal();

  return (
    <div className="d-lg-flex justify-content-between">
      <StoreCompanyStatusModal
        title="Création d'un statut d'entreprise"
        ref={StoreCompanyStatusModalRef}
      />
      <ManageCompanyStatusPermissionsModal
        title="Gestion des permissions par rôle"
        ref={ManagePermissionsModalRef}
      />
      <Row className="flex-between-center gy-2 px-x1">
        <Col xs="auto" className="pe-0">
          <h6 className="mb-0">Statuts d'entreprise</h6>
        </Col>
        <Col xs="auto">
          <InputGroup className="position-relative input-search-width">
            <FormControl
              size="sm"
              id="search"
              type="search"
              className="shadow-none"
              placeholder="Rechercher"
              onChange={(e) => onQueryChange(e.target.value)}
            />
            <Button
              size="sm"
              variant="outline-secondary"
              className="border-300 hover-border-secondary"
            >
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </InputGroup>
        </Col>
      </Row>
      <div className="border-bottom border-200 my-3"></div>
      <div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
        <div id="orders-actions">
          <IconButton
            variant="nolina-default"
            size="sm"
            icon={faShieldAlt}
            transform="shrink-3"
            iconAlign="middle"
            onClick={openPermissionsModal}
            className="mx-2"
          >
            <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
              Permissions
            </span>
          </IconButton>
          <IconButton
            variant="nolina-default"
            size="sm"
            icon={faPlus}
            transform="shrink-3"
            iconAlign="middle"
            onClick={openCreateModal}
            className="mx-2"
          >
            <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
              Nouveau
            </span>
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default AllCompanyStatusesHeader;
